var map = {
	"./UserManagement/roles.json": 825,
	"./UserManagement/users.json": 7207,
	"./buttons.json": 4594,
	"./common.json": 6204,
	"./dashboard.json": 3378,
	"./fields.json": 7981,
	"./navigation.json": 9705,
	"./permissions.json": 9535,
	"./topBar.json": 4349,
	"./validations.json": 4713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8236;